<div class="form-modal modal-xl" id="product-choose-modal">
    <h1 mat-dialog-title>{{ 'CHOOSE_PRODUCT' | translate}}</h1>
    <div mat-dialog-content>
      <div class="form-horizontal">
        <div class="row" *ngIf="filterDate">
          <form [formGroup]="form" class="form-horizontal">
            <div class="col-sm-4">
              <mat-form-field class="allwidth" >
                <input matInput placeholder="{{ 'BEGIN_DATE' | translate}}" 
                  class="one date-picker"  formControlName="dataInicio">
                  <i matSuffix class="far fa-calendar-alt bigger-110"></i>
              </mat-form-field>
            </div>
            <div class="col-sm-4">
              <mat-form-field class="allwidth" >
                <input matInput placeholder="{{ 'END_DATE' | translate}}"
                  class="one date-picker"  formControlName="dataFim">
                  <i matSuffix class="far fa-calendar-alt bigger-110"></i>
              </mat-form-field>
            </div>
            <div class="col-sm-4">
              <button type="button" class="btn btn-default" (click)="onClickFilterDates()" [disabled]="form.invalid">
                <i class="fas fa-search iconSearch"></i>
                &nbsp;{{ 'BUTTON.SEARCH' | translate }}
              </button>
            </div>
          </form>
        </div>
        <div class="row">
  
          <div class="col-sm-12">
            <table id="tableChoose" class="table table-bordered display" cellspacing="0" cdkFocusInitial tabindex="0">
              <thead>
                <tr>
                    <th rowspan="2"></th>
                    <th>
                      <strong>{{'CODE'|translate}}</strong>
                    </th>
                    <th>
                      <strong>{{'NAME'|translate}}</strong>
                    </th>
                    <th></th>
                </tr>
                <tr>
                  <!-- CODE -->
                    <th>
                      <mat-form-field class="full-width findInputContainer">
                        <input type="text" matInput placeholder="{{'FILTER'|translate}}" class="findInput" [(ngModel)]="productService.datatableParametersBaglass.columns[1]">
                      </mat-form-field>
                    </th>
                    
                    <!-- NAME -->
                    <th>
                      <mat-form-field class="full-width findInputContainer">
                        <input type="text" matInput placeholder="{{'FILTER'|translate}}" class="findInput" [(ngModel)]="productService.datatableParametersBaglass.columns[3]">
                      </mat-form-field>
                    </th>
                    <th></th>
                </tr>
              </thead>
              <tbody></tbody>
            </table>
          </div>
  
        </div>
      </div>
    </div>
    <div mat-dialog-actions>
      <div class="col-md-12 no-padding text-right modal-theme">
        <button type="button" class="btn btn-default" title="{{'BUTTON.CANCEL' | translate}}" (click)="cancel()">
          {{'BUTTON.CANCEL' | translate}}
        </button>
        
        <button *ngIf="allowNone" type="button" class="btn btn-default" title="{{'BUTTON.CLEAR' | translate}}" (click)="removerSeleccao()">
          {{'BUTTON.CLEAR' | translate}}
        </button>
      </div>
    </div>
  </div>